import React, {useState, useEffect} from 'react'
import classes from './About.module.css'
import {MDBContainer, MDBCol, MDBRow} from "mdbreact";
import {Helmet} from "react-helmet";
import {returnTran} from "../../Utils/Trans";
import firebase from "firebase";
import { Capacitor} from '@capacitor/core';
const db = firebase.firestore()

const About = (props) => {
    //step 1:change to false
    const [isDonationOn, setIsDonationOn] = useState(Capacitor.getPlatform() === "web")

    useEffect(() => {
        //step 2
        if(Capacitor.getPlatform() !== "web"){
            getDonationState()
        }
    }, [])

    const getDonationState = () => {
        //step 3
        db.collection('Setting')
            .doc('HomeSetting')
            .get()
            .then(res => {
                if (res.exists) {
                    setIsDonationOn(res.data().isDonationOn)
                }
            })
    }

    return (
        <MDBContainer>
            <Helmet>
                <title> {returnTran("LeftNavBar", "about-us") + ' | MeWeSearcher'}</title>
                <meta property="og:type" content="website"/>
                <meta property="site_name" content="MeWeSearcher"/>
                <meta property="title" content={'MeWeSearcher'}/>
                <meta name="description" content={returnTran("Homepage", "share-msg")}/>
                <meta name="keywords" content={"mewe, search mewe, 找尋mewe群組, 香港mewe"}/>
                <meta property="og:title"
                      content={'MeWeSearcher'}/>
                <meta property="og:description" content={returnTran("Homepage", "share-msg")}/>
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:site_name"
                      content={"MeWeSearcher | " + returnTran("Homepage", "share-msg")}/>
                {/*<meta property="og:updated_time"*/}
                {/*      content={new Date(this.state.article.lastModified.hasOwnProperty('seconds') ? this.state.article.lastModified.seconds * 1000 : this.state.article.lastModified._seconds * 1000 ).toISOString()}/>*/}
                <meta httpEquiv="content-language"
                      content={localStorage.getItem("i18n-lang") === "en" ? "en-us" : "zh-Hant"}/>
                <meta property="og:type" content="article"/>
                <meta property="og:image" content={"https://imgur.com/a/AMU0634"}/>
                <meta property="og:image:width" content="1280"/>
                <meta property="og:image:height" content="720"/>
                {/*<link rel="amphtml" href={"https://clipversity.com/amp/article/" + this.state.article.key}/>*/}
            </Helmet>
            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <div className={classes.AboutMeContainer}>
                        <h1>
                            我是誰？
                        </h1>
                        <div className={classes.AboutDescription}>
                            我是一個Slasher(educator | programmer |
                            creator)，可惜自今年疫情開始，不少原本的工作都一一被取消，令我只可以依靠積蓄及少量互工作渡過了2020年。
                            {isDonationOn && "可以的話，給我一杯咖啡，減輕我在網站伺服器開支。"}
                        </div>

                        <div className={classes.ButtonContainer}>
                            {
                                isDonationOn &&
                                <button className={classes.SupportBtn}>
                                    <a href={'https://ko-fi.com/mewesearcher'} target={"_blank"}>
                                        💪 支持本站
                                    </a>
                                </button>
                            }


                            <button className={classes.ContactBtn}>
                                <a href={'mailto:mewesearcher@gmail.com'} target={"_blank"}>
                                    📞 聯絡我合作
                                </a>
                            </button>
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    )
}
export default About